<template>
  <div data-app>
    
    <group-card title="Document Details" icon="info" padded>
      <template slot="actions">
        <!-- <loading-icon-text-button icon="link" @click="showXeroDialog=true">Add New Document Type</loading-icon-text-button>
        <loading-icon-text-button icon="save" @click="save">Save</loading-icon-text-button> -->
      </template>

      <md-card-content>
        <group-card icon="contacts" padded title="Basic">
          <div class="md-layout input-layout">
            <validated-text-input label="Name" v-model="document_type.name"
                                  class="md-layout-item md-small-size-15 md-size-15" required></validated-text-input>
            <validated-text-input label="Description" v-model="document_type.description"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-text-input>
            <validated-text-input label="Accepted File Type" v-model="document_type.accepted_file_types"
                                    class="md-layout-item md-small-size-25 md-size-25"></validated-text-input>
            <validated-select-input label="Active" required :options="['Yes','No']"
                                    v-model="document_type.active"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-select-input>
            <validated-select-input label="Required Authetication" required :options="['Yes','No']"
                                    v-model="document_type.require_authentication"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-select-input>
            
          </div>
        </group-card>
        
      </md-card-content>
      <md-card-actions>
        <md-button class="md-primary"
                   @click="save">
          <md-icon>save</md-icon>
          Save
        </md-button>
      </md-card-actions>
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import filters from "@/components/utils/filters";
import {newLender, newProduct, newDocumentType} from "@/schema.js";
import {mapGetters} from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import ValidatedTextInput from "../components/ValidatedInput/ValidatedTextInput";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";
import LoadingIconTextButton from "../components/LoadingIconTextButton";
import ValidatedEmailInput from "../components/ValidatedInput/ValidatedEmailInput";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import NotificationCard from "../components/Cards/NotificationCard";
import WaitingDialog from "../components/Dialogs/WaitingDialog";

export default {
  components: {
    NotificationCard,
    ValidatedEmailInput,
    LoadingIconTextButton,
    ValidatedNumberInput,
    ValidatedSelectInput,
    ValidatedTextInput,
    GroupCard,
    ...ValidatedInputs,
  },
  data() {
    return {
      document_type: newDocumentType(),
    }
  },
  methods: {
    addNewProduct() {
      this.products.push(newProduct());
    },
    async showAlertDialog(title, message) {
      return await this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: "Delete",
        cancelText: 'Close',
      });
    },
    async save() {
      this.showLoadingDialog('Saving', 'Please wait whilst the document type detail is being saved.');
      await axios.post('/api/v1/administration/document_type/save', {
        document_type: this.document_type,
      });
      await this.getExisting();
      if (this.$modal.submit) {
        this.$modal.submit();
      }
    },
    async getExisting() {
      const document_type_id = this.$route.params.document_type_id;
      if (document_type_id && document_type_id != 'new') {
        let response = await axios.get(`/api/v1/administration/document_type/${document_type_id}/view`);
        this.document_type = response.data;
        this.document_type.active = (this.document_type.active == 1) ? 'Yes' : 'No';
        this.document_type.require_authentication = (this.document_type.require_authentication == 1) ? 'Yes' : 'No';
      }
    },
    
    showLoadingDialog(title, message) {
      this.$modal.show(WaitingDialog, {
        title: title,
        message: message,
      });
    },
    
  },
  mounted() {
    this.getExisting();
  }
}
</script>
